module.exports = __webpack_public_path__ + "static/media/frame_45.fcf44e1b.jpg";